var map = {
	"./mask-240323.svg": "e14e",
	"./mask-241903.svg": "9435",
	"./mask-circle.svg": "d326",
	"./mask-curvey-polygon.svg": "5af9",
	"./mask-octogon.svg": "89f4",
	"./mask-oval.svg": "aa84",
	"./mask-star.svg": "8eb5",
	"./mask-triangle.svg": "48c5",
	"./mask-triangle_2_1.svg": "1a5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64e5";